import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { IQuoteState, QuoteState } from '@nibtravel/shared/data-access/quote';

@Injectable()
export class HomeSelector {
  @Selector([QuoteState])
  static isPolicyHoldersDirty(quote: IQuoteState): boolean {
    const policyHolders = quote.input.policyHolders;
    return policyHolders.length ? policyHolders.some((ph) => !!ph.guid) : false;
  }
}
